'use client';
import { useState, useEffect } from 'react';
import { Skeleton } from 'primereact/skeleton';
import { Gallery } from './imageGallery';

const GallerySkeleton = ({ coverImage, productName }) => (
    <div>
        {/* Hidden cover image — stays in server HTML for SEO crawlers */}
        {coverImage && (
            <img
                src={coverImage}
                alt={productName || 'Product image'}
                aria-hidden="true"
                style={{ display: 'none' }}
            />
        )}
        {/* Skeleton UI shown while JS loads */}
        <Skeleton width="100%" height="360px" borderRadius="14px" className="mb-2" />
        <div style={{ display: 'flex', gap: 8, justifyContent: 'center', marginTop: 10 }}>
            {[1, 2, 3, 4, 5].map(i => (
                <Skeleton key={i} width="58px" height="58px" borderRadius="8px" />
            ))}
        </div>
    </div>
);

export const GalleryWrapper = ({ data, coverImageId, coverImage, productName }) => {
    const [mounted, setMounted] = useState(false);

    useEffect(() => { setMounted(true); }, []);

    return (
        <div>
            {!mounted && (
                <GallerySkeleton coverImage={coverImage} productName={productName} />
            )}
            {mounted && (
                <Gallery
                    data={data}
                    coverImageId={coverImageId}
                    coverImage={coverImage}
                    productName={productName}
                />
            )}
        </div>
    );
};
